import { useState } from "react";
import { showToast } from "../../Components/Toast";
import axiosInstance from "../../Utils/axiosInstance";
import dayjs from "dayjs";
import { getProposalData } from "../Services/Proposals";

export const handleUploadProposal = async (formData, params) => {
    try {
        // 🔹 Start loader
        params.api.updateRows([
            {
                id: params.id,
                Proposal_Uploading: true,
                Proposal_Status: "Uploading"
            }
        ]);

        const resp = await axiosInstance.post(
            "/api/file_handling/addProposal",
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (!resp || resp.status !== 200 || !resp.data?.status) {
            throw new Error(resp?.data?.message || "Upload failed");
        }

        const proposalData = resp?.data?.data;

        // IMPORTANT: update SAME field names as grid rows
        params.api.updateRows([
            {
                id: params.id,
                Proposal_ID: proposalData?.Proposal_ID,
                Proposal_File_Path: proposalData?.Path,
                Proposal_Status: "Uploaded",
                Proposal_Uploading: false,
                Last_Updated_Time: proposalData?.Last_Updated_Time
            }
        ]);

        showToast({
            message: `Proposal uploaded`,
            type: "success"
        });

        return proposalData;
    } catch (err) {
        params.api.updateRows([
            {
                id: params.id,
                Proposal_Uploading: false,
                Proposal_Status: "Upload Failed"
            }
        ]);

        showToast({
            message:
                err?.response?.data?.message ||
                err?.message ||
                "Proposal upload failed",
            type: "error"
        });

        throw err;
    }
};

export const handleDeleteProposal = async (rowId, proposalId, params) => {
    try {
        // 🔹 start delete loader
        params.api.updateRows([
            {
                id: rowId,
                Proposal_Deleting: true
            }
        ]);

        const resp = await axiosInstance.post(
            "/api/file_handling/deleteProposal",
            {
                Proposal_ID: proposalId,
                CORFQ_ID: params?.row?.CORFQ_ID
            }
        );

        if (!resp || resp.status !== 200 || !resp.data?.status) {
            throw new Error(resp?.data?.message || "Delete failed");
        }

        // const proposalsResponse = await getProposalData("");

        // const lastUpdatedTimeInit = proposalsResponse?.data?.map(
        //   (eachProposalRec: any) => {
        //     if (eachProposalRec?.CORFQ_No === rowId) {
        //       return eachProposalRec?.Last_Updated_Time;
        //     }
        //   }
        // );
        const proposalData = resp?.data?.data;
        // success → clear proposal fields
        params.api.updateRows([
            {
                id: rowId,
                Last_Updated_Time: proposalData?.Last_Updated_Time,
                Proposal_ID: "",
                Proposal_File_Path: "",
                Proposal_File_Name: "",
                Proposal_Status: "Yet to Upload",
                Proposal_Deleting: false
            }
        ]);

        showToast({
            message: `Proposal deleted`,
            type: "error"
        });

        return resp.data;
    } catch (err) {
        // ❌ stop loader on error
        params.api.updateRows([
            {
                id: rowId,
                Proposal_Deleting: false
            }
        ]);

        showToast({
            message:
                err?.response?.data?.message ||
                err?.message ||
                "Failed to delete proposal",
            type: "error"
        });

        throw err;
    }
};

export const loadRowDatesFromStorage = () => {
    try {
        const data = localStorage.getItem("rowDateMap");
        return data ? JSON.parse(data) : {};
    } catch (err) {
        console.error("Failed to parse localStorage rowDateMap", err);
        return {};
    }
};

export const updateProposalStatus = async (newStatus: string, params: any) => {
    try {
        const resp = await axiosInstance.post(
            "/api/key_account_management/updateProposalStatus",
            {
                Proposal_ID: params.row?.Proposal_ID || null,
                Proposal_Status: newStatus || null
            }
        );

        if (!resp || resp.status !== 200 || !resp.data?.status) {
            throw new Error(resp?.data?.message || "Failed to update status");
        }

        if (newStatus === "Approved") {
            showToast({
                message: `Proposal ${newStatus}`,
                type: "success"
            });
        } else if (newStatus === "Rejected") {
            showToast({
                message: `Proposal ${newStatus} `,
                type: "error"
            });
        }

        const proposalData = resp?.data?.data;

        params.api.updateRows([
            {
                id: params.id,
                Last_Updated_Time: proposalData?.Last_Updated_Time
            }
        ]);

        return resp.data;
    } catch (err) {
        console.error("updateProposalStatus error:", err);
        throw err;
    }
};

export const parseCustomDate = (dateStr: string) => {
    return dayjs(dateStr, "DD-MMM-YYYY HH:mm:ss").toDate();
};
